import type { Data } from '@strapi/types';
import { useQuery } from '@tanstack/react-query';

import { getStatuses } from '../api/document-status.api';

export const useDocumentStatusesInit = (
	projectId: Pick<Data.Entity<'api::project.project'>, 'documentId'>['documentId'],
	isProjectOpen = false,
) => {
	const {
		data: documentStatuses,
		isPending,
		error,
	} = useQuery({
		queryKey: ['GET_DOCUMENT_STATUSES', projectId],
		queryFn: () => getStatuses({ projectId }),
		enabled: isProjectOpen && !!projectId,
	});

	return {
		documentStatuses,
		isPending,
		error,
	};
};
